import { render, staticRenderFns } from "./StorageSpaceChangeActivationType.vue?vue&type=template&id=26effa56&"
import script from "./StorageSpaceChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports